var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.inited,
          expression: "inited"
        }
      ]
    },
    [
      _c(
        "h3",
        { staticClass: "mb-5", attrs: { "data-cy": "step-config-modal" } },
        [
          _vm._v(
            " Configurar paso " +
              _vm._s(_vm.step.numeroPaso) +
              " de " +
              _vm._s(_vm.steps.length) +
              " "
          )
        ]
      ),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-6" },
          [
            _c(
              "vs-select",
              {
                ref: "stepType",
                staticClass: "w-100",
                attrs: {
                  autocomplete: "",
                  label: "Tipo de paso",
                  name: "stepType",
                  disabled: _vm.readOnly
                },
                on: {
                  change: function($event) {
                    return _vm.cleanSurrogate()
                  }
                },
                model: {
                  value: _vm.currentStep.aprobacionesTipoPasoId,
                  callback: function($$v) {
                    _vm.$set(_vm.currentStep, "aprobacionesTipoPasoId", $$v)
                  },
                  expression: "currentStep.aprobacionesTipoPasoId"
                }
              },
              _vm._l(_vm.stepTypesAvalaibles, function(type) {
                return _c("vs-select-item", {
                  key: type.opcionId,
                  attrs: { value: type.valor, text: type.descripcion }
                })
              }),
              1
            )
          ],
          1
        ),
        _vm.currentStep.aprobacionesTipoPasoId === _vm.stepTypesMap.GROUP
          ? _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("list-groups", {
                  staticClass: "w-100",
                  attrs: {
                    autocomplete: "",
                    label: "Grupo del responsable",
                    name: "groupInput",
                    isClearable: false,
                    typeList: _vm.currentStep.aprobacionesTipoPasoId,
                    disabled: _vm.readOnly
                  },
                  on: {
                    "full-group": function($event) {
                      _vm.currentStep.responsable = $event.label
                    }
                  },
                  model: {
                    value: _vm.currentStep.tipoValorResponsableId,
                    callback: function($$v) {
                      _vm.$set(_vm.currentStep, "tipoValorResponsableId", $$v)
                    },
                    expression: "currentStep.tipoValorResponsableId"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.currentStep.aprobacionesTipoPasoId === _vm.stepTypesMap.USER
          ? _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("list-user", {
                  staticClass: "w-100",
                  attrs: {
                    autocomplete: "",
                    label: "Usuario",
                    isClearable: false,
                    name: "userInput",
                    disabled: _vm.readOnly
                  },
                  on: {
                    "full-user": function($event) {
                      _vm.currentStep.responsable = $event.label
                    }
                  },
                  model: {
                    value: _vm.currentStep.tipoValorResponsableId,
                    callback: function($$v) {
                      _vm.$set(_vm.currentStep, "tipoValorResponsableId", $$v)
                    },
                    expression: "currentStep.tipoValorResponsableId"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          { staticClass: "col-6 mb-5" },
          [
            _c(
              "vs-select",
              {
                staticClass: "w-100",
                attrs: {
                  autocomplete: "",
                  label: "Tipo de rol",
                  name: "rolType",
                  disabled: _vm.readOnly
                },
                model: {
                  value: _vm.currentStep.aprobacionesTipoRolId,
                  callback: function($$v) {
                    _vm.$set(_vm.currentStep, "aprobacionesTipoRolId", $$v)
                  },
                  expression: "currentStep.aprobacionesTipoRolId"
                }
              },
              _vm._l(_vm.rolTypesAvalaibles, function(rol) {
                return _c("vs-select-item", {
                  key: rol.opcionId,
                  attrs: { value: rol.valor, text: rol.descripcion }
                })
              }),
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c("label", [
              _vm._v(" Límite (Días) "),
              _vm.currentStep.demoraMaxHoras > 0
                ? _c("span", [
                    _vm._v(
                      "- " + _vm._s(_vm.currentStep.demoraMaxHoras) + " días"
                    )
                  ])
                : _vm._e()
            ]),
            !_vm.readOnly
              ? _c("vs-slider", {
                  staticClass: "mt-1",
                  attrs: { min: 0, max: 31 },
                  model: {
                    value: _vm.currentStep.demoraMaxHoras,
                    callback: function($$v) {
                      _vm.$set(_vm.currentStep, "demoraMaxHoras", $$v)
                    },
                    expression: "currentStep.demoraMaxHoras"
                  }
                })
              : _vm._e(),
            !_vm.readOnly
              ? _c("small", { staticClass: "advice" }, [
                  _vm._v(
                    " Si este paso no es procesado, se notificará después del tiempo límite "
                  )
                ])
              : _vm._e()
          ],
          1
        )
      ]),
      _vm.currentStep.aprobacionesTipoPasoId === _vm.stepTypesMap.GROUP ||
      _vm.flowType === "P"
        ? _c("div", { staticClass: "row mt-3" }, [
            _vm.currentStep.aprobacionesTipoPasoId === _vm.stepTypesMap.GROUP
              ? _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c("label", [_vm._v("Cantidad mínima aprobación")]),
                    _c("b-form-input", {
                      staticClass: "w-100",
                      attrs: { disabled: _vm.readOnly, type: "number" },
                      model: {
                        value: _vm.currentStep.cantidadMinAprobacion,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.currentStep,
                            "cantidadMinAprobacion",
                            _vm._n($$v)
                          )
                        },
                        expression: "currentStep.cantidadMinAprobacion"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.currentStep.aprobacionesTipoPasoId === _vm.stepTypesMap.GROUP
              ? _c(
                  "div",
                  { staticClass: "col-6 d-flex align-items-center" },
                  [
                    _c("label", { staticClass: "mr-2 mb-0" }, [
                      _vm._v("Carga distribuida")
                    ]),
                    _c("vs-switch", {
                      attrs: { disabled: _vm.readOnly },
                      model: {
                        value: _vm.currentStep.distributed,
                        callback: function($$v) {
                          _vm.$set(_vm.currentStep, "distributed", $$v)
                        },
                        expression: "currentStep.distributed"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.flowType === "P"
              ? _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c(
                      "vs-select",
                      {
                        staticClass: "w-100",
                        attrs: {
                          autocomplete: "",
                          label: "Tipo de moneda",
                          name: "stepType",
                          disabled: _vm.readOnly
                        },
                        model: {
                          value: _vm.currentStep.desdePrecioMoneda,
                          callback: function($$v) {
                            _vm.$set(_vm.currentStep, "desdePrecioMoneda", $$v)
                          },
                          expression: "currentStep.desdePrecioMoneda"
                        }
                      },
                      _vm._l(_vm.currencyOptions, function(item) {
                        return _c("vs-select-item", {
                          key: item.id,
                          attrs: { value: item.id, text: item.nombre }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm.flowType === "P"
              ? _c(
                  "div",
                  { staticClass: "col-6 mb-5" },
                  [
                    _c("label", [_vm._v("Precio desde")]),
                    _c("b-form-input", {
                      attrs: { disabled: _vm.readOnly, type: "number" },
                      model: {
                        value: _vm.currentStep.desdePrecio,
                        callback: function($$v) {
                          _vm.$set(_vm.currentStep, "desdePrecio", _vm._n($$v))
                        },
                        expression: "currentStep.desdePrecio"
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        : _vm._e(),
      _vm.steps.length !== _vm.currentStep.numeroPaso &&
      1 !== _vm.currentStep.numeroPaso
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.readOnly,
                  expression: "!readOnly"
                }
              ],
              staticClass: "row"
            },
            [
              _c("div", { staticClass: "col-6 mt-2 mb-3" }, [
                _c(
                  "div",
                  { staticClass: "d-flex align-items-center mt-5" },
                  [
                    _c("label", { staticClass: "mr-2 mb-0" }, [
                      _vm._v("Disparar proceso ")
                    ]),
                    _c("vs-switch", {
                      model: {
                        value: _vm.trigger,
                        callback: function($$v) {
                          _vm.trigger = $$v
                        },
                        expression: "trigger"
                      }
                    })
                  ],
                  1
                )
              ])
            ]
          )
        : _vm._e(),
      _vm.trigger
        ? _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c("Consequences", {
                  attrs: {
                    reference: _vm.reference,
                    original: _vm.currentStep.gatillaciones,
                    readOnly: _vm.readOnly
                  },
                  on: { consequences: _vm.addConsequences }
                }),
                _c("hr")
              ],
              1
            )
          ])
        : _vm._e(),
      _vm.currentStep.aprobacionesTipoPasoId === _vm.stepTypesMap.USER
        ? _c("div", { staticClass: "row mb-5" }, [
            _c("div", { staticClass: "col-6" }, [
              _c(
                "div",
                { staticClass: "d-flex align-items-center mt-5" },
                [
                  _c("label", { staticClass: "mr-2 mb-0" }, [
                    _vm._v("Subrogado ")
                  ]),
                  _c("vs-switch", {
                    attrs: { disabled: _vm.readOnly },
                    on: {
                      change: function($event) {
                        return _vm.cleanSurrogate()
                      }
                    },
                    model: {
                      value: _vm.surrogate,
                      callback: function($$v) {
                        _vm.surrogate = $$v
                      },
                      expression: "surrogate"
                    }
                  })
                ],
                1
              )
            ]),
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("list-user", {
                  staticClass: "w-100",
                  attrs: {
                    autocomplete: "",
                    label: " ",
                    name: "surrogate",
                    disabled: _vm.readOnly || !_vm.surrogate
                  },
                  on: {
                    "full-user": function($event) {
                      _vm.currentStep.subrogado = $event.label
                    }
                  },
                  model: {
                    value: _vm.currentStep.subrogadoId,
                    callback: function($$v) {
                      _vm.$set(_vm.currentStep, "subrogadoId", $$v)
                    },
                    expression: "currentStep.subrogadoId"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("label", [_vm._v("Desde")]),
                _c("b-form-datepicker", {
                  staticClass: "w-100",
                  attrs: {
                    disabled: _vm.readOnly || !_vm.surrogate,
                    "label-no-date-selected": "Seleccione la fecha",
                    "label-help": "",
                    "hide-header": "",
                    min: _vm.minDate,
                    "start-weekday": "1",
                    dropleft: ""
                  },
                  model: {
                    value: _vm.from,
                    callback: function($$v) {
                      _vm.from = $$v
                    },
                    expression: "from"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("label", [_vm._v("Hasta")]),
                _c("b-form-datepicker", {
                  staticClass: "w-100",
                  attrs: {
                    disabled: _vm.readOnly || !_vm.surrogate,
                    "label-no-date-selected": "Seleccione la fecha",
                    "label-help": "",
                    "hide-header": "",
                    "start-weekday": "1",
                    dropright: "",
                    min: _vm.from
                  },
                  model: {
                    value: _vm.to,
                    callback: function($$v) {
                      _vm.to = $$v
                    },
                    expression: "to"
                  }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _vm.currentStep.aprobacionesTipoRolId === _vm.rolTypes.SIGNER
        ? _c("div", { staticClass: "row mb-5" }, [
            _vm._m(0),
            _c("div", { staticClass: "col-6" }, [
              _c("label", [_vm._v("Página")]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.currentStep.pagina,
                    expression: "currentStep.pagina"
                  }
                ],
                staticClass: "form-control",
                attrs: { readonly: "", type: "number" },
                domProps: { value: _vm.currentStep.pagina },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.currentStep, "pagina", $event.target.value)
                  }
                }
              })
            ]),
            _c("div", { staticClass: "col-6 col-md-6" }, [
              _c("label", [_vm._v("Posición X")]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.currentStep.x,
                    expression: "currentStep.x"
                  }
                ],
                staticClass: "form-control",
                attrs: { readonly: "", "data-cy": "x" },
                domProps: { value: _vm.currentStep.x },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.currentStep, "x", $event.target.value)
                  }
                }
              })
            ]),
            _c("div", { staticClass: "col-6 col-md-6" }, [
              _c("label", [_vm._v("Posición Y")]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.currentStep.y,
                    expression: "currentStep.y"
                  }
                ],
                staticClass: "form-control",
                attrs: { readonly: "", "data-cy": "y" },
                domProps: { value: _vm.currentStep.y },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.currentStep, "y", $event.target.value)
                  }
                }
              })
            ])
          ])
        : _vm._e(),
      _vm.extraConfig.requeridos
        ? _c(
            "div",
            { staticClass: "row" },
            [
              _c("div", { staticClass: "col-12" }, [
                _c("div", { staticClass: "d-flex align-items-center mt-5" }, [
                  _c("h4", [
                    _vm._v(
                      _vm._s(
                        _vm.extraConfig.requeridosTitle ||
                          "Configuraciones requeridas"
                      )
                    )
                  ])
                ])
              ]),
              _vm._l(_vm.extraConfig.requeridos, function(field, index) {
                return _c("div", { key: index, staticClass: "col-6" }, [
                  _c("label", { attrs: { for: "required-" + field.valor } }, [
                    _vm._v(" " + _vm._s(field.label) + " ")
                  ]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.requeridos[field.valor],
                        expression: "requeridos[field.valor]"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { name: "required-" + field.valor },
                    domProps: { value: _vm.requeridos[field.valor] },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.requeridos,
                          field.valor,
                          $event.target.value
                        )
                      }
                    }
                  })
                ])
              })
            ],
            2
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "mt-5 w-100 d-flex justify-content-end" },
        [
          !_vm.readOnly
            ? _c(
                "b-button",
                {
                  staticClass: "mt-5 mr-5",
                  attrs: { variant: "warning" },
                  on: { click: _vm.modify }
                },
                [_vm._v(" Modificar ")]
              )
            : _vm._e(),
          _c(
            "b-button",
            {
              staticClass: "mt-5 mr-5",
              attrs: { variant: "primary" },
              on: {
                click: function($event) {
                  return _vm.$emit("close")
                }
              }
            },
            [_vm._v(" " + _vm._s(_vm.readOnly ? "Cerrar" : "Cancelar") + " ")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-6" }, [
      _c("div", { staticClass: "d-flex align-items-center mt-5" }, [
        _c("h4", [_vm._v("Posición pre definida de la firma")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }